import { jsx } from 'react/jsx-runtime';
import { useCallback, createElement } from 'react';
import Skeleton from '@mui/material/Skeleton';
import '../Table/Table.js';
import '../Table/TableHeader.js';
import '../Table/TableBody.js';
import '../Table/TableEmptyState.js';
import '../Table/TableList.js';
import '../Table/HeaderRow/TableHeaderRow.js';
import '../Table/HeaderCell/TableHeaderCell.js';
import TableDataCell from '../Table/DataCell/TableDataCell.js';
import '../Table/DataRow/TableDataRow.js';
import { SCROLLBAR_WIDTH } from '../constants.js';

const useRowRenderHelper = (rowOptions) => {
    const { rows, prepareRow, rowHeight, rtl, Row, onRowClick, onRowDoubleClick, onRowsDragHandler, canDropOnRow, isRowHidden, clickedRowId, selectedRowIds, rowSkeleton, enableRowClickSelection, enableRowDragging, enableCheckboxSelection, loading, valueService, disableSortBy, toggleAllRowsSelected, columnResizingShift, getRowMenu, denseRowContextMenu, rowCellPadding, onRowContextMenuOpen, onRowContextMenuClose, onRowFocus, } = rowOptions;
    const RenderRow = useCallback(({ index, style, data: { width, height, itemSize } }) => {
        const row = rows[index];
        prepareRow(row);
        const isRowLoading = row.original && row.original.__loading;
        return (jsx(Row, Object.assign({}, row.getRowProps({ style }), { "data-testid": `${index}-row`, className: `data-table-row-${index}`, rowHeight: rowHeight, "aria-selected": row.values.id == clickedRowId, index: index, row: row, rtl: rtl, checked: row.isSelected, getRowMenu: getRowMenu, onRowClick: onRowClick, onRowFocus: onRowFocus, onRowDoubleClick: onRowDoubleClick, onRowsDrag: onRowsDragHandler, canDropOnRow: canDropOnRow, isRowHidden: isRowHidden, clickedRowId: clickedRowId, selectedRowIds: selectedRowIds, denseRowContextMenu: denseRowContextMenu, width: width, itemsCount: Math.floor(height / itemSize), scrollbarWidth: SCROLLBAR_WIDTH, skeleton: rowSkeleton, loading: loading, enableRowClickSelection: enableRowClickSelection, enableRowDragging: enableRowDragging && (selectedRowIds[row.id] || !Object.keys(selectedRowIds).length), enableCheckboxSelection: enableCheckboxSelection, columnResizingShift: columnResizingShift, onRowContextMenuOpen: onRowContextMenuOpen, onRowContextMenuClose: onRowContextMenuClose }, { children: row.cells.map((cell, cellIndex) => {
                return (createElement(TableDataCell, Object.assign({}, cell.getCellProps(), { rtl: rtl, key: cellIndex, "data-testid": `grid-row-${index}-${cell.column.id}`, rowCellPadding: rowCellPadding }), !(loading || isRowLoading) ? (cell.render('Cell', {
                    value: valueService.valueGetter(row, cell.column),
                })) : cell.column.id !== 'row-menu-column' ? (jsx(Skeleton, { width: "80%", height: 28, animation: 'wave' })) : null));
            }) })));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rows,
        prepareRow,
        Row,
        rowHeight,
        getRowMenu,
        onRowClick,
        onRowDoubleClick,
        onRowsDragHandler,
        canDropOnRow,
        isRowHidden,
        clickedRowId,
        selectedRowIds,
        SCROLLBAR_WIDTH,
        disableSortBy,
        enableRowClickSelection,
        enableRowDragging,
        toggleAllRowsSelected,
        loading,
    ]);
    return {
        RenderRow,
    };
};

export { useRowRenderHelper };
//# sourceMappingURL=useRowRenderHelper.js.map
